export const canRequestAnnexation = (region, profile, hasOpenAnnexation = false) => Boolean(
  profile?.country_id
  && Number(profile.diplo_points || 0) >= 1
  && !hasOpenAnnexation
  && region
  && Number(region.country_id || 0) !== Number(profile.country_id)
  && (!region.country_id || region.is_played === false)
)

/**
 * À qui la carte propose-t-elle d'écrire.
 *
 * Trois refus, et chacun évite qu'un écran présente une action que le serveur
 * rejettera — ce qui, pour le joueur, ressemble à une panne :
 *
 *  - **soi-même** : `open_country_channel` refuse explicitement (« Un pays ne
 *    s'écrit pas à lui-même ») ;
 *  - **un pays fantôme** (`is_played === false`) : une région attribuée à un
 *    pays sans gouvernement. Il y en a eu jusqu'à 428 sur cette carte, un tiers
 *    du monde. Le canal s'ouvrirait sur personne, et `can_read` répondrait 403 ;
 *  - **un visiteur anonyme** : sans siège, il n'y a ni « mon pays » ni
 *    expéditeur. Le bouton ne doit pas être grisé, il ne doit pas exister.
 *
 * Vit ici, hors du composant, pour être vérifiable sans navigateur : le
 * parcours au clic met deux minutes à voir un pays fraîchement fondé, le temps
 * que la file du GeoJSON régénère la carte. Une condition pure n'a pas à
 * attendre ça pour être testée.
 */
export const canOpenCountryChannel = (region, profile) => Boolean(
  profile?.country_id
  && region
  && region.country_id
  && region.is_played !== false
  && Number(region.country_id) !== Number(profile.country_id)
)
